import styled from '@emotion/styled';
import { ADD_BUTTON_HEIGHT, ADD_BUTTON_WIDTH } from './addButtonConstants';
import Handle from './Handle';

// At times we're going to replace the OverlayButton with PlacementButton,
// and Flow layout works out nicer if they are the same height, so they don't
// need any repositioning.
const ConsistentHeightWrapper = styled.div`
  display: flex;
  align-items: center;
  height: ${ADD_BUTTON_HEIGHT}px;
`;

export default function HiddenAddButton() {
  return (
    <ConsistentHeightWrapper>
      <div
        style={{
          width: ADD_BUTTON_WIDTH,
          height: '30px',
          position: 'relative',
        }}
      >
        <Handle
          id="handle-left"
          type="target"
          position="left"
          style={{ left: '100%', right: 'auto' }}
        />
        <Handle
          id="handle-right"
          type="source"
          position="right"
          style={{ right: 0 }}
        />
      </div>
    </ConsistentHeightWrapper>
  );
}
